<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import CrmService from '@/services/crm'

moment.locale('pt-BR');

export default {
  page: {
    title: "CRM",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "CRM",

      loading: false,
      crms: [],
      customer: {},
      crm: {},
      user: {},
      showCrmModal: false,
      crmSelectedId: '',

      searchParams: {
        term: '',
        startDate: '',
        endDate: '',
        period: true,
      },
      showModal: false,
      searchEmptyField: false,
      activity: {},
      status: '',
      sellers: [],

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      fields: [],

      interactionsData: [],
      invoiceData: {
        items: []
      },
      showInvoiceModal: false,
      showInteractionsModal: false,
      itemsInvoiceFields: [
        { key: 'sequence', sortable: true, label: 'Item' },
        { key: 'product.code', sortable: true, label: 'Código' },
        { key: 'product.description', sortable: true, label: 'Produto' },
        { key: 'quantity', sortable: true, label: 'Qtde.' },
        { key: 'price', sortable: true, label: 'Valor Unitário', formatter: (value, key, item) => {
          return (item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'total', sortable: true, label: 'Valor Total', formatter: (value, key, item) => {
          return (item.quantity * item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } }
      ],
      interactionsFields: [
        { key: 'date', sortable: false, label: 'Data e Hora', formatter: (value) => {
          if (value) return moment(value).format('DD/MM/YYYY HH:mm:ss');
          return '';
        } },
        { key: 'attendance', sortable: false, label: 'Tipo Atendimento' },
        { key: 'content', sortable: false, label: 'Conteúdo' },
      ]
    };
  },
  mounted() {
    CrmService.getSellers().then(res => {
      this.sellers = res.data;
    })

    this.$store.dispatch('USER_DATA').then((res) => {
      this.user = res;
    })

    this.status = this.$route.name;

    this.fields = [
      { key: 'date', sortable: true, label: 'Data', formatter: (value) => {
        return moment(value).format('DD/MM/YYYY HH:mm:ss');
      } },
      { key: 'userName', sortable: true, label: 'Operador' },
      { key: 'customer', sortable: true, label: 'Cliente', formatter: (value) => {
        return `${value.code} - ${value.name}`
      } },
      { key: 'city', sortable: true, label: 'Cidade/UF', formatter: (value, key, item) => {
        return `${item.customer.city}/${item.customer.state}`
      } },
      { key: 'sellerName', sortable: true, label: 'Vendedor' },
      { key: 'type', sortable: true, label: 'Grupo' },
      { key: 'origin', sortable: true, label: 'Origem' },
      { key: 'lastInvoice', sortable: true, label: 'Data Última NF', formatter: (value) => {
        if (value) return moment(value.date).format('DD/MM/YYYY');
        return '';
      } }
    ]

    if (this.status === 'crm-open') {
      this.fields.push(
        { key: 'rescheduleDate', sortable: true, label: 'Data Reagendamento', formatter: (value) => {
          return moment(value).format('DD/MM/YYYY');
        }
      });
    }

    this.fields.push({ key: 'actions', label: 'Ações', class: 'nowrap-col' });

    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.search();
  },
  methods: {
    search() {
      this.searchEmptyField = false;
      this.loadCrms();
    },
    loadCrms(page = 1) {
      this.loading = true;

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      this.searchParams.page = page;
      this.searchParams.status = this.status;

      CrmService.getAll(this.searchParams)
        .then(res => {
          this.loading = false;

          this.crms = res.data.crms;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalSales = res.data.totalSales;
          this.totalCanceledSales = res.data.totalCanceledSales;
          this.totalValidSales = res.data.totalValidSales;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCrms(this.currentPage);
    },
    exportData() {
      this.loading = true;

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      this.searchParams.status = this.status;

      CrmService.export(this.searchParams).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        const fileName = this.status === 'crm-open' ? 'CRM_Abertos' : 'CRM_Fechados';

        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${fileName}.xlsx`);
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
    details(activity) {
      this.activity = activity;
      this.showModal = true;
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY HH:mm:ss');
    },
    changeSearch() {
      if (this.searchParams.term === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCrms(1);
      }
    },
    seeInvoiceData(item) {
      this.showInvoiceModal = true;
      this.invoiceData = item;
    },
    seeInteractionsData(item) {
      this.showInteractionsModal = true;
      this.interactionsData = item.interactions;
    },
    newCrmInteraction(crm) {
      this.customer = crm.customer;
      this.crm = {
        _id: crm._id,
        type: crm.type.toLowerCase(),
        origin: crm.origin.toLowerCase(),
        customer: crm.customer._id,
        content: '',
        reschedule: false,
        rescheduleDate: null,
        edit: false,
      };
      this.showCrmModal = true;
    },
    editCrm(crm) {
      const lastInteraction = crm.interactions[crm.interactions.length - 1];

      this.customer = crm.customer;
      this.crm = {
        _id: crm._id,
        type: crm.type.toLowerCase(),
        origin: crm.origin.toLowerCase(),
        customer: crm.customer._id,
        reschedule: crm.reschedule,
        rescheduleDate: crm.rescheduleDate ? new Date(crm.rescheduleDate) : '',
        edit: true,

        content: lastInteraction.content,
        attendance: lastInteraction.attendanceKey,
      };
      this.showCrmModal = true;
    },
    confirmRemoveCrm(data) {
      this.crmSelectedId = data._id;
      this.$bvModal.show('modal-remove');
    },
    removeCrm() {
      this.$bvModal.hide('modal-remove');

      CrmService.remove(this.crmSelectedId).then(() => {
        this.$toast.open('Interação CRM removida com sucesso');

        this.loadCrms();
      }).catch(() => {
        this.$toast.error('Não foi possível remover a interação. Tente novamente.')
      })
    },
    saveCrm() {
      if (!this.crm.type) {
        return this.$toast.info('Informe o tipo da interação');
      }

      if (!this.crm.origin) {
        return this.$toast.info('Informe a origem da interação');
      }

      if (!this.crm.content) {
        return this.$toast.info('Informe o conteúdo da interação');
      }

      if (this.crm.reschedule && !this.crm.rescheduleDate) {
        return this.$toast.info('Informe a data de reagendamento');
      }

      CrmService.create(this.crm).then(() => {
        this.$toast.open('Interação CRM criada com sucesso');
        
        this.showCrmModal = false;

        if (!this.crm.reschedule) {
          this.$router.push('/crm-closed');
        } else {
          this.loadCrms();
        }
      }).catch(() => {
        this.$toast.error('Não foi possível criar a interação. Tente novamente.')
      })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-4 col-sm-8">
                  <label>Código, CNPJ, Razão Social ou Nome Fantasia</label>
                  <input
                    type="text"
                    v-model="searchParams.term"
                    class="form-control"
                  />
                </div>

                <div class="col col-3">
                  <label>Operador</label>
                  <select class="form-control" v-model="searchParams.user" @keydown.esc.prevent="searchParams.user = ''">
                    <option value=""></option>
                    <option v-for="seller in sellers" :key="seller.seller._id" :value="seller.seller._id">{{seller.name}}</option>
                  </select>
                </div>
              </div>
                  
              <div class="custom-control custom-checkbox mb-2 mt-3">
                <input type="checkbox" class="custom-control-input" id="customCheck1" v-model="searchParams.period" />
                <label class="custom-control-label" for="customCheck1">Período</label>
              </div>

              <div class="row">
                <div class="col-2">
                  <div class="form-group mb-3">
                    <!-- <label>Período de</label> -->
                    <date-picker
                      v-model="searchParams.startDate"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      lang="pt-br"
                      :disabled="!searchParams.period"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-2">
                  <div class="form-group mb-3">
                    <!-- <label>até</label> -->
                    <date-picker
                      v-model="searchParams.endDate"
                      :first-day-of-week="1"
                      format="DD/MM/YYYY"
                      lang="pt-br"
                      :disabled="!searchParams.period"
                    ></date-picker>
                  </div>
                </div>
              </div>
                <!-- </div>
              </div> -->

              <div class="row">
                <div class="col-3">
                  <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                  <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                  <a href="javascript:void(0);" class="text-primary" v-if="loading">
                    <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                  </a>
                </div>
              </div>

              <!-- <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>

                <b-button type="submit" class="text-sm-right" variant="primary" v-if="!loading">Filtrar</b-button>
              </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="crms"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(lastInvoice)="row">
                  <div class="invoice-data" v-show="row.value">
                    {{row.value}}
                    <a href="javascript:void(0);" v-b-tooltip.hover.top title="Visualizar Dados da NF" class="action-icon text-success ml-1" @click="seeInvoiceData(row.item.lastInvoice)">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>
                  </div>
                </template>

                <template v-slot:cell(actions)="row">
                  <div class="inline">
                    <a href="javascript:void(0);" v-b-tooltip.hover.top title="Nova Interação" class="action-icon text-primary mr-2" v-if="status === 'crm-open' && user.name === row.item.userName" @click="newCrmInteraction(row.item)">
                      <i class="mdi mdi-plus-circle font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);" v-b-tooltip.hover.top title="Visualizar Interações" class="action-icon text-primary mr-2" @click="seeInteractionsData(row.item)">
                      <i class="mdi mdi-format-list-bulleted font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);" v-b-tooltip.hover.top title="Editar" class="action-icon text-primary mr-2" v-if="status === 'crm-open' && user.name === row.item.userName" @click="editCrm(row.item)">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);" v-b-tooltip.hover.top title="Excluir" class="action-icon text-danger" v-if="user.name === row.item.userName" @click="confirmRemoveCrm(row.item)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>
          <!-- end col-->
          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
          <!-- end col-->
        </div>
      </div>
    </div>

    <b-modal v-model="showModal" title="Detalhes da Atividade" centered>
      <div class="customer-detail">
        <div class="field">
          <p class="title">Cliente:</p>
          <p>{{activity.customerName}}</p>
        </div>
        <div class="field">
          <p class="title">Data:</p>
          <p>{{formatDate(activity.date)}}</p>
        </div>
        <div class="field">
          <p class="title">Tipo:</p>
          <p>{{activity.type}}</p>
        </div>
        <div class="field">
          <p class="title">Conteúdo:</p>
          <p>{{activity.content}}</p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showInvoiceModal"
      body-class="p-3"
      size="lg"
      scrollable
    >
      <template v-slot:modal-header>
        <div class="header-invoice">
          <h5 class="modal-title text-black font-18">Detalhes da Nota Fiscal</h5>

          <div class="invoice-info mt-1">
            <p class="mb-0">Número NF: {{invoiceData.number}}-{{invoiceData.series}}</p>
            <p class="mb-0">Data: {{formatDate(invoiceData.date)}}</p>
            <p class="mb-0">Valor NF: {{invoiceData.totalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</p>
          </div>
        </div>
      </template>

      <b-table
        bordered
        small
        :items="invoiceData.items"
        :fields="itemsInvoiceFields"
        responsive="sm"
      >
      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showInvoiceModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showInteractionsModal"
      body-class="p-3"
      scrollable
      title="Interações"
      size="lg"
    >
      <b-table
        bordered
        small
        :items="interactionsData"
        :fields="interactionsFields"
        responsive="sm"
      >
      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showInteractionsModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showCrmModal"
      :title="crm.edit ? 'Editar Última Interação CRM' : 'Nova Interação CRM'"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="saveCrm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Cliente</label>
              <input
                id="name"
                v-model="customer.name"
                type="text"
                class="form-control"
                disabled
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Grupo</label>
              <select
                v-model="crm.type"
                class="form-control"
                name="crmType"
                disabled
              >
                <option value="bike">BIKE</option>
                <option value="mobilidade">MOBILIDADE</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Tipo Atendimento</label>
              <select
                v-model="crm.attendance"
                class="form-control"
                name="attendance"
              >
                <option value="phone">Telefone</option>
                <option value="visit">Visita</option>
                <option value="email">E-mail</option>
                <option value="whatsapp">Whatsapp</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Origem</label>
              <select
                v-model="crm.origin"
                class="form-control"
                name="crmOrigin"
                disabled
              >
                <option value="mob">MOB</option>
                <option value="app">APP</option>
                <option value="web">WEB</option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Conteúdo</label>
              <textarea
                v-model="crm.content"
                class="form-control"
                name="content"
                rows="5"
                :maxlength="300"
                @keydown.enter.prevent="handleEnter"
              ></textarea>
              <div class="text-left">
                <p
                  v-if="crm.content"
                  class="badge position-absolute"
                  :class="{ 'badge-primary': crm.content.length !== 300,
                            'badge-danger': crm.content.length === 300 }"
                >
                  {{ crm.content.length }} /
                  300
                </p>
              </div>
            </div>
          </div>

          <div class="col col-6 mt-3">
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="reschedule" v-model="crm.reschedule" />
              <label class="custom-control-label" for="reschedule">Reagendar?</label>
            </div>

            <date-picker
              v-if="crm.reschedule"
              v-model="crm.rescheduleDate"
              :first-day-of-week="1"
              format="DD/MM/YYYY"
              lang="pt-br"
            ></date-picker>
          </div>
        </div>

        <div class="text-right pt-4 mt-3">
          <b-button variant="link" @click="showCrmModal = false">Cancelar</b-button>
          <b-button type="submit" variant="primary" class="ml-2">{{crm.edit ? 'Editar Interação' : 'Criar Interação'}}</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="modal-remove"
      title="Confirmação"
      title-class="font-18"
      centered
    >
      <p>Tem certeza que deseja excluir as interações desse CRM? Não será possível recuperar após a exclusão.</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeCrm">Excluir CRM</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .customer-detail {
    .field {
      display: flex;
      flex-direction: row;

      p {
        margin-bottom: 8px;

        &.title {
          font-weight: 600;
          color: #000;
          margin-right: 16px;
        }
      }
    }
  }

  .invoice-data {
    white-space: nowrap;
  }

  .invoice-data a {
    line-height: 0px;
  }

  .inline {
    white-space: nowrap;
  }

  .form-control:disabled {
    background-color: #e8e8e8 !important;
  }
</style>